

const loginReducer = {
    loginResponse: {},
    loginLoading: true,
    loginError: null,

    verifyOtpLoading: true,
    verifyOtpResponse: {},
    verifyOtpError: null,

    forgotPasswordLoading: true,
    forgotPasswordError: null,
    forgotPasswordResponse: {},

    changePasswordLoading: true,
    changePasswordResponse: {},
    changePasswordError: null,

}

const dashboardReducer = {
    dashboardResponse: {},
    dashboardLoading: true,
    dashboardError: null,
    dashboardList: [],
}

const adminPPReducer = {
    adminppList: [],

    adminPPResponse: [],
    adminPPLoading: false,
    adminPPError: null,

    adminPPAddResponse: [],
    adminPPAddLoading: false,
    adminPPAddError: null,

    adminPPEditResponse: [],
    adminPPEditLoading: false,
    adminPPEditError: null,

    adminPPGetIdResponse: [],
    adminPPGetIdLoading: false,
    adminPPGetIdError: null,

    adminStatusResponse: [],
    adminStatusLoading: false,
    adminStatusError: null,
}


const hospitalReducer = {
    hospitalList: [],

    hospitalPharmacyResponse: [],
    hospitalPharamacyLoading: false,
    hospitalPharamacyError: null,

    hospitalFacilityResponse: {},
    hospitalFacilityLoading: false,
    hospitalFacilityError: null,

    regionListResponse: [],
    regionListLoading: false,
    regionListError: null,

    pharmacyListResponse: [],
    pharmacyListLoading: false,
    pharmacyListError: null,

    pharmacyCreateResponse: [],
    pharmacyCreateLoading: false,
    pharmacyCreateError: null,


    pharmacyUpdateLoading: true,
    pharmacyUpdateResponse: [],
    pharmacyUpdateError: null,

    aslGetLoading: true,
    aslGetResponse: [],
    aslGetError: null,

    regionASLListLoading: true,
    regionASLListResponse: [],
    regionASLListError: null,

}

const calendarReducer = {
    calendarAddLoading: true,
    calendarAddResponse: [],
    calendarAddeError: null,

    hospitalPharamacyCalendarLoading: false,
    hospitalPharamacyCalendarResponse: [],
    hospitalPharamacyCalendarError: null,


    calendarUpdateLoading: true,
    calendarUpdateResponse: [],
    calendarUpdateError: null,

}

const commonstate = {
    menuItemsUser: [
        {
            label: "Dashboard",
            icon: "pi pi-home",
            url: "/dashboard",
        },
        {
            label: "Users",
            icon: "pi pi-users",
            url: "/user",
        },
    ],
    patientGetByIdData: []

}
const commonReducer = {
    isSidebarView: false,
    loginData: {},
    resetPwd:false,
    getPatientData: {},
    translateResponse: [],
    translateLoading: false,
    translateError: null,

    getAuthenticationTypeLoading: false,
    getAuthenticationTypeResponse: [],
    getAuthenticationTypeError: null,

}

const patientReducer = {
    patientResponse: [],
    patientLoading: false,
    patientError: null,

    patientListLoading: false,
    patientListResponse: [],
    patientListError: null,

    patientUpgradeLoading: false,
    patientUpgradeResponse: [],
    patientUpgradeError: null,

    patientGetIdLoading: false,
    patientGetIdResponse: [],
    patientGetIdError: null,

    patientUpdateLoading: false,
    patientUpdateResponse: [],
    patientUpdateError: null,

    patientDeleteLoading: false,
    patientDeleteResponse: [],
    patientDeleteError: null,
}

const structureReducer = {
    structureListResponse: [],
    structureListLoading: false,
    structureListError: null,

    structureGetIdResponse: [],
    structureGetIdLoading: false,
    structureGetIdError: null,

    structureUpdateResponse: [],
    structureUpdateLoading: false,
    structureUpdateError: null,

    structureContactResponse: [],
    structureContactLoading: false,
    structureContactError: null,

    structureDeleteResponse: [],
    structureDeleteLoading: false,
    structureDeleteError: null,


    structureContactUpdateResponse: [],
    structureContactUpdateLoading: false,
    structureContactUpdateError: null,
    structurePreviousSelectedId: null

}
const planTherapeuticReducer = {
    therapeuticListLoading: false,
    therapeuticListResponse: [],
    therapeuticListError: null,

    therapeuticCreateLoading: false,
    therapeuticCreateResponse: [],
    therapeuticCreateError: null,

    therapeuticDrugListLoading: false,
    therapeuticDrugListResponse: [],
    therapeuticDrugListError: null,

    therapeuticUpdateLoading: false,
    therapeuticUpdateResponse: [],
    therapeuticUpdateError: null,

    therapeuticDeleteLoading: false,
    therapeuticDeleteResponse: [],
    therapeuticDeleteError: null,


}

const retailReducer = {

    retailLoading: false,
    retailResponse: [],
    retailError: null,

    retailPharamacyLoading: false,
    retailPharamacyError: null,
    retailPharamacyResponse: [],

    retailGetIdLoading: false,
    retailGetIdResponse: [],
    retailGetIdError: null,

    retailUpdateLoading: false,
    retailUpdateResponse: [],
    retailUpdateError: null,
}
const allergiesReducer = {
    allergiesAddLoading: false,
    allergiesAddResponse: [],
    allergiesAddeError: null,

    allergiesUpdateLoading: false,
    allergiesUpdateResponse: [],
    allergiesUpdateError: null,

    allergiesGetIdLoading: false,
    allergiesGetIdResponse: [],
    allergiesGetIdError: null,

    allergiesGetAllIdLoading: false,
    allergiesGetAllIdResponse: [],
    allergiesGetAllIdError: null,

    allergiesDeleteLoading: false,
    allergiesDeleteResponse: [],
    allergiesDeleteError: null,

}

const attachmentAnalysisReducer = {
    attachmentAnalysisAddLoading: false,
    attachmentAnalysisAddResponse: [],
    attachmentAnalysisAddError: null,

    attachmentAnalysisUpdateLoading: false,
    attachmentAnalysisUpdateResponse: [],
    attachmentAnalysisUpdateError: null,

    attachmentAnalysisGetIdLoading: false,
    attachmentAnalysisGetIdResponse: [],
    attachmentAnalysisGetIdError: null,

    attachmentAnalysisGetAllIdLoading: false,
    attachmentAnalysisGetAllIdResponse: [],
    attachmentAnalysisGetAllIdError: null,

    attachmentAnalysisDeleteLoading: false,
    attachmentAnalysisDeleteResponse: [],
    attachmentAnalysisDeleteError: null,

}

const eventAllergiesReducer = {
    eventallergiesAddLoading: false,
    eventallergiesAddResponse: [],
    eventallergiesAddeError: null,

    eventallergiesUpdateLoading: false,
    eventallergiesUpdateResponse: [],
    eventallergiesUpdateError: null,

    eventallergiesGetIdLoading: false,
    eventallergiesGetIdResponse: [],
    eventallergiesGetIdError: null,

    eventallergiesGetAllIdLoading: false,
    eventallergiesGetAllIdResponse: [],
    eventallergiesGetAllIdError: null,

    eventallergiesDeleteLoading: false,
    eventallergiesDeleteResponse: [],
    eventallergiesDeleteError: null,

}

const drugsReducer = {

    drugsGetAllIdLoading: false,
    drugsGetAllIdResponse: [],
    drugsGetAllIdError: null,

    drugsAddLoading: false,
    drugsAddResponse: [],
    drugsAddeError: null,


    // ----for dropdown-------

    // Product type dropdown api
    productTypeDropdownLoading: false,
    productTypeDropdownResponse: [],
    productTypeDropdownError: null,

    // Class dropdown api
    classDropdownGetLoading: false,
    classDropdownGetResponse: [],
    classDropdownGetError: null,

    // recipe type dropdown api    
    recipeTypeDropdownGetLoading: false,
    recipeTypeDropdownGetResponse: [],
    recipeTypeDropdownGetError: null,

    // Region DD dropdown api
    regionDropdownDDLoading: false,
    regionDropdownDDResponse: [],
    regionDropdownDDError: null,

    // Region DPC dropdown api
    regionDropdownDPCLoading: false,
    regionDropdownDPCResponse: [],
    regionDropdownDPCError: null,

    // Pharameutical forms dropdown api
    pharameuticalFormsDropdownLoading: false,
    pharameuticalFormsDropdownResponse: [],
    pharameuticalFormsDropdownError: null,

    // Temperature dropdown api
    temperatureDropdowndLoading: false,
    temperatureDropdowndResponse: [],
    temperatureDropdowndError: null,


}

export const initialStore = {
    loginReducer: loginReducer,
    dashboardReducer: dashboardReducer,
    commonstate: commonstate,
    commonReducer: commonReducer,
    adminPPReducer: adminPPReducer,
    hospitalReducer: hospitalReducer,
    patientReducer: patientReducer,
    structureReducer: structureReducer,
    retailReducer: retailReducer,
    calendarReducer: calendarReducer,
    planTherapeuticReducer: planTherapeuticReducer,
    eventAllergiesReducer: eventAllergiesReducer,
    allergiesReducer: allergiesReducer,
    attachmentAnalysisReducer: attachmentAnalysisReducer,
    drugsReducer: drugsReducer

}